import React from "react"
import SEO from "../components/SEO"

const AboutPage = () => (
  <>
    <h1>About Me</h1>
    <p>Hello I'm Suraj.</p>
    <p>
      Professionally I'm a product manager and my current focus is on <a href="https://cube.global/solutions/technology">creating understandable and actionable insights for people on planetscale data</a>.
    </p>
    <p>I am a trustee and board member for the <a href="https://integratedtransport.org.uk/">Foundation for Integrated Transport</a>, through which I support transformational grant making and impact investment into sustainable transport solutions within the UK.</p>
    <p>As a person I'm happiest working in teams looking to solve large problems. These can be for people, organisations or even machines. Overall I aim to create the best outcomes combining design, technology and data.</p>
    <p>You may like to explore my <a href="/projects">projects</a> or some of my <a href="/journal">thinking and writing</a>, sign up to my occasional <a href="/newsletter">newsletter</a>, or sign my <a href="/guestbook">guestbook</a>?</p>
    <h4>Shall we collaborate on something?</h4>
    <p>
      I'm always open for talking through ideas, problems and more. Feel free to send me a message using <a href="/contact">my contact details</a>.
    </p>
  </>
)

export default AboutPage
